import type { ActiveCohortSession } from '../../services/circles.service';

/**
 * Which live cohort session, if any, this banner should announce.
 *
 * Sessions the viewer walked out of are SKIPPED. The feed returns them —
 * someone who left still needs a route back, and "Your Groups" gives them a
 * persistent Enter button on the group itself — but a banner is a
 * notification, and re-announcing a circle you deliberately left is the
 * nagging that 9fd6df1a was right to stop. Same behaviour as before; it used
 * to live in the endpoint's WHERE clause, where it also (wrongly) took away
 * the only way back.
 *
 * Most recently started wins when there is more than one.
 */
export function pickBannerSession(sessions: ActiveCohortSession[]): ActiveCohortSession | null {
  const joinable = sessions.filter((s) => !s.viewer_has_left);
  if (joinable.length === 0) return null;

  return [...joinable].sort((a, b) => (b.started_at ?? '').localeCompare(a.started_at ?? ''))[0];
}
